import { Box, Drawer, Grid2, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TicketTypeEnum } from "../../_common/enum/ticketType.enum";
import { StandardButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { ticketPurgeLogService } from "../../_services/ticketPurgeLog.service";
import { getDate } from "../../_helpers/dateTime.helper";
import { getEnumKey } from "../../_helpers/enum.helper";
import { DataTypeAutoComplete } from "../../_components/autocomplete/dataType.autocomplete";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";


export const TicketPurgeLogManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const resetData = () => ({});

    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [ticketTypeId, setTicketTypeId] = useState<TicketTypeEnum | null>(null);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        resetData();

        setIsLoading(true);
        return ticketPurgeLogService
            .get(startDate?.toString() || "", endDate?.toString() || "", ticketTypeId || null)
            .then(
                (json) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return ticketPurgeLogService
            .post(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Purge Tickets"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="startDate"
                            name="startDate"
                            label="Start Date"
                            type="date"
                            fullWidth
                            required
                            validators={['required']}
                            errorMessages={['required field']}
                            value={startDate}
                            onChange={(e: any) => setStartDate(e.target.value)}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="endDate"
                            name="endDate"
                            label="End Date"
                            type="date"
                            fullWidth
                            required
                            validators={['required']}
                            errorMessages={['required field']}
                            value={endDate}
                            onChange={(e: any) => setEndDate(e.target.value)}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 size={{ xs: 12 }}>
                            <DataTypeAutoComplete
                                key="ticketTypeId"
                                dataType={DataTypeEnum.TicketType}
                                label="Select Ticket Type"
                                hasParent={false}
                                value={ticketTypeId}
                                name={"ticketTypeId"}
                                onChange={(e: any) => setTicketTypeId(e.target.value)}
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardButton
                            saving={saving}
                            loading={isLoading}
                            icon="add"
                            onClick={fetchData}>
                            Get Tickets
                        </StandardButton>
                    </Grid2>


                    {data?.tickets?.map((_data: any, index: any) => (
                        <Grid2 size={{ xs: 12 }} key={index}>
                            <Paper
                                elevation={1}
                                sx={{
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    borderRadius: 2,
                                    backgroundColor: '#f9f9f9',
                                    '&:hover': {
                                        backgroundColor: '#f1f1f1',
                                    },
                                }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                    <Typography variant="body1" mr={2}>Ticket: {_data.ticketReferenceNumber}</Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                    <Typography variant="body1" mr={2}>{getEnumKey(_data.ticketTypeId, TicketTypeEnum)}</Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                    <Typography variant="body1" mr={2}>Payment Date: {_data.paymentDate != null ? getDate(_data.paymentDate) : ""}</Typography>
                                </Box>
                            </Paper>
                        </Grid2>
                    ))}

                    {data?.tickets?.length > 0 &&
                        <Grid2 size={{ xs: 12 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="save"
                                type="submit">
                                Save
                            </StandardButton>
                        </Grid2>
                    }
                </Grid2>


            </ValidatorForm>
        </Drawer>
    );
};